import React, { useEffect, useState } from "react";
import AdminSidebar from "./components/Sidebar";
import Header from "./components/Header";
import "../../css/admin/patientsList.scss";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Link } from "react-router-dom";
import DeletePatient from "./DeletePatient";
import apiClient from "../../api/clinet";

interface Props {}
const PatientsList: React.FC<Props> = (Props) => {
  interface Ipatient {
    name: string;
    phoneNumber: number;
    patientId: number;
    fatherName: string;
    id: number;
  }
  const [listOfPatients, setListOfPatients] = useState<Ipatient[]>();

  useEffect(() => {
    apiClient.get("/patients").then((response) => {
      setListOfPatients(response?.data?.listOfPatients);
    });
  }, []);

  useEffect(() => {}, [listOfPatients]);

  const patientsList = listOfPatients?.map((value) => {
    return (
      <tr key={value.id}>
        <td>
          <DeletePatient id={value.id} />

          <Link to={`../Admin/EditPatient/${value.id}`}>
            <EditOutlinedIcon />
          </Link>
        </td>
        <td>{value.phoneNumber}</td>
        <td>{value.patientId}</td>
        <td>{value.fatherName}</td>
        <td>{value.name}</td>
        <td></td>
      </tr>
    );
  });

  return (
    <div className="patientContainer">
      <AdminSidebar />
      <div className="leftColumnPatients">
        <Header />
        <div className="patientsList">
          <div className="createButtonContainer">
            <Link to="/Admin/AddPatient" className="createButton">
              اضافه کردن مددجو
            </Link>
          </div>
          {
            <table>
              <tbody>
                <tr>
                  <th>حذف سطر</th>
                  <th>شماره تماس</th>
                  <th>کد ملی</th>
                  <th>نام پدر</th>
                  <th>اسم</th>
                  <th>شماره سطر</th>
                </tr>
                {patientsList}
              </tbody>
            </table>
          }
        </div>
      </div>
    </div>
  );
};

export default PatientsList;
